export default __webpack_public_path__ + "static/media/contact-lawyers.b02303d7.gif";